// From https://github.com/processing/p5.js/blob/master/utils/sample-linter.js
const P5UserFunctions = [
  'draw',
  'setup',
  'preload',
  'mousePressed',
  'mouseDragged',
  'mouseMoved',
  'mouseReleased',
  'mouseClicked',
  'mouseWheel',
  'doubleClicked',
  'windowResized',
  'touchStarted',
  'touchMoved',
  'touchEnded',
  'deviceMoved',
  'deviceTurned',
  'deviceShaken',
  'keyPressed',
  'keyReleased',
  'keyTyped'
];
// P5UserFunctions = P5UserFunctions.slice(0, 2);

module.exports = P5UserFunctions;
